module.exports = __webpack_public_path__ + "img/empty-track.bbef8af0.png";